import styled from "styled-components";

export const Overlay = styled.div`
  position: fixed;
  inset: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 99999;

  @media (max-width: 768px) {
    max-width: 100vw;
  }
`;

export const Wrapper = styled.div`
  max-width: 700px;

  @media (max-width: 768px) {
    margin: 24px;
  }
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  padding: 12px;
  background: ${(p) => p.theme.colors["warning"]};
  color: ${(p) => p.theme.colors.on["warning"]};
`;

export const HeadingWrapper = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 15px;
`;

export const Heading = styled.h2`
  transform: translateX(-36px);
`;

export const Icon = styled.i`
  font-size: 4rem;
  color: ${(p) => p.theme.altColors.warning};
  padding-left: 12px;
  justify-self: start;
`;

export const MessageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  background-color: #fff;
  padding: 24px;
`;

export const Message = styled.p`
  font-size: 1.2rem;
  margin: 0;
  text-align: center;
`;
